import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import NotFound from "./components/NotFound/NotFound";

export default function App() {
    return (
        <div className="flex min-h-screen flex-col bg-background text-foreground">
            <Header />
            <div className="flex-1">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
}
